module.exports = __webpack_public_path__ + "img/send-bg.845087a2.svg";